    import { homeImages } from "./data";
    import { Swiper, SwiperSlide } from "swiper/react"; 
    import { Autoplay } from "swiper/modules"; 
    import "swiper/css"; 
import "swiper/css/autoplay";
 import { img } from "framer-motion/m";

export function TrackRecords() {
  const videos = [
    { img: "https://img.youtube.com/vi/AxGaF7ojCq0/hqdefault.jpg", link: "https://www.youtube.com/watch?v=AxGaF7ojCq0", title: "Parents Speak" },
    { img: "https://img.youtube.com/vi/7tayvdVih2c/hqdefault.jpg", link: "https://www.youtube.com/watch?v=7tayvdVih2c", title: "Campus Tour" },
    { img: "https://img.youtube.com/vi/8kMY7IAGIGc/hqdefault.jpg", link: "https://www.youtube.com/watch?v=8kMY7IAGIGc", title: "NEET Results" },
    { img: "https://img.youtube.com/vi/YUm7w4csKTI/hqdefault.jpg", link: "https://www.youtube.com/watch?v=YUm7w4csKTI", title: "Student Journey" },
  ];

  return (
    <section className="relative overflow-hidden py-1 sm:py-2">
      {/* Elegant background */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50" />
        <div className="absolute -top-24 -left-24 h-80 w-80 rounded-full bg-emerald-200/40 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-teal-200/30 blur-3xl" />
        <svg className="absolute inset-x-0 top-0 h-[180px] w-full opacity-40" viewBox="0 0 1440 180" aria-hidden>
          <defs>
            <pattern id="grid" width="32" height="32" patternUnits="userSpaceOnUse">
              <path d="M32 0V32 M0 32H32" className="stroke-teal-300/30" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="1440" height="180" fill="url(#grid)" />
        </svg>
      </div>

      <div className="mx-auto max-w-7xl px-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold sm:text-3xl">
            Where Every Student’s Story Becomes a Record‑Breaking Chapter
          </h2>
          <p className="mt-3 text-sm text-neutral-600">Real journeys • Real outcomes • Real inspiration</p>
        </div>

        <div className="mt-8 md:mt-10">
          {/* Swiper is expected to be installed at app level */}
          <div className="[&_.swiper]:pb-6">
            <Swiper
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{ 640: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
              loop={true}
              autoplay={{ delay: 2800, disableOnInteraction: false, pauseOnMouseEnter: true }}
              modules={[Autoplay]}
            >
              {videos.map((video, i) => (
                <SwiperSlide key={i}>
                  <a href={video.link} target="_blank" rel="noopener noreferrer" className="block group">
                    <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200 transition duration-300 group-hover:-translate-y-1 group-hover:shadow-md">
                      {/* No sticker/overlay; clean thumbnail with soft gradient edge */}
                      <div className="relative">
                        <img
                          src={video.img}
                          alt={video.title}
                          loading="lazy"
                          className="aspect-video w-full object-cover"
                        />
                        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-neutral-900/10 to-transparent" />
                      </div>
                      <div className="flex items-center justify-between px-4 py-3">
                        <span className="text-sm font-semibold text-neutral-800">{video.title}</span>
                        <span className="text-xs text-teal-700">Watch on YouTube →</span>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Legacy + Stats block with refined visuals */}
        <div className="mt-2 grid items-center gap-8 lg:grid-cols-2">
          <div>
            <h3 className="inline-block rounded-xl bg-teal-600 px-4 py-2 text-sm font-semibold text-white">14 Years of Legacy</h3>
            <p className="mt-4 text-lg leading-relaxed text-neutral-700">
              With a legacy spanning over 14 years, Rankridge Junior College has established itself as a powerhouse in
              competitive exam coaching for IIT‑JEE, NEET‑UG & EAMCET. Our students don’t just appear—they dominate.
            </p>
            <ul className="mt-4 space-y-2 text-sm font-medium text-neutral-800">
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" /> 99% success rate across IIT & NEET long‑term programs</li>
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" /> Hundreds of selections into IITs, AIIMS, NITs & IIITs</li>
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" /> Top ranks in Engineering, Medicine & Pharmacy streams</li>
            </ul>
          </div>
          <div>
            <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200">
              <img src={homeImages[0]} alt="Rankridge Results" className="h-auto w-full object-contain" loading="lazy" />
            </div>
          </div>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[
            "1400+ All India Top Ranks in IIT‑JEE",
            "20+ AIIMS Admissions via NEET",
            "95%+ NEET Success Rate (5 years)",
            "99.99 Percentiles in JEE Mains",
            "95% of Students Selected in IITs",
            "3000+ EAMCET Selections",
          ].map((t) => (
            <div key={t} className="rounded-2xl bg-white p-6 text-center shadow-sm ring-1 ring-neutral-200">
              <p className="text-lg font-semibold text-neutral-800">{t}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-neutral-200">
          <h4 className="text-xl font-semibold text-neutral-900">What Makes Our Track Record Exceptional?</h4>
          <ul className="mt-4 grid gap-2 text-sm sm:grid-cols-2">
            {[
              "100% result‑oriented academic ecosystem",
              "Expert faculty from IITs, NITs & AIIMS",
              "Rankridge Study Modules (RSMs)",
              "Daily + weekly exams & AI performance tracking",
              "Individual mentorship & 24×7 support",
              "Full‑length mock exams & revision camps",
            ].map((t) => (
              <li key={t} className="flex gap-2 text-neutral-700"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" /> {t}</li>
            ))}
          </ul>
        </div>

        <div className="mt-12 text-center">
          <h4 className="text-2xl font-bold">Rankridge’s Impact Across India</h4>
          <p className="mt-3 text-lg text-neutral-700">
            From Telangana to IIT Bombay, IIT Madras, IIT Delhi, IIT Kharagpur, IIT Kanpur, AIIMS Delhi & NIT Warangal—our alumni are doctors, engineers & leaders. This isn’t just a record. It’s a legacy.
          </p>
          <div className="mt-8 rounded-2xl bg-neutral-900 p-6 text-white">
            <p className="text-lg font-semibold">Choose Rankridge – Where Every Rank Has a Story</p>
            <p className="mt-1 text-sm text-neutral-300">Join the next batch of IITians, AIIMS doctors & EAMCET toppers.</p>
            <div className="mt-4 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a href="tel:+919959271353" className="inline-flex items-center justify-center rounded-xl bg-teal-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700">📞 99 59 271 353</a>
              <a href="https://www.rankridgecollege.com" target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/20 px-5 py-3 text-sm font-semibold hover:bg-white hover:text-neutral-900">www.rankridgecollege.com</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
